// Mirrored in ExternalAPI as PortalTypes
export enum InstanceTypes {
  None = 0,
  ClientPortal = 1,
  CsrPortal = 2,
  EmployeePortal = 4,
  LandingPortal = 8,
  All = ClientPortal | CsrPortal | EmployeePortal | LandingPortal
}

export class PortalInfo {
  InstanceType: InstanceTypes;
  DisplayName: string;
  Roles: string[];
  Url: string;
  Icon: string;
}
